import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/Icons/warningIcon.svg";

const WarningIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default WarningIcon;
